module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAElBMVEUAAAAyMjIzMzMyMjIyMjIzMzOlWAvnAAAABXRSTlMA0FDg38CRrTEAAAAgSURBVBjTY1AMhQMnBlMEJ5AhlAEOQkcqBzlAkIPKCABLQBxTAx2a5gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/70.png
// module id = ezUd
// module chunks = 1